import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import { Modal, Progress, Card, Typography, Input, Upload, message, Button, Form, notification } from 'antd';
import { saveFeedback } from '../../actions/Authentication-action';

import { getChapterStatus } from '../../actions/User-action';
import { action } from '../../store';
import { CheckCircleFilled, CloseCircleFilled, UploadOutlined, SendOutlined  } from '@ant-design/icons';
import PanelSpinner from "./PanelSpinner";
import "./Dashboard.scss";

const { Title } = Typography;
const { TextArea } = Input;
const fullInput = { display: 'inline-block', width: 'calc(100% - 8px)' }


const selectedCSS = {
    position: "absolute",
    top: "36px",
    transform: `translate( -50%, -50% )`, right: "10px", color: "#87d068", fontSize: "20px"
};
const rejectedCSS = { position: "absolute", transform: `translate( -50%, -50% )`, top: "36px", right: "10px", color: "red", fontSize: "20px" };

const Dashboard = ({ chapters, isPreAssessmentDone, userId, isAllChapterDone, isPostAssessmentDone, profile, loading }) => {
   
    const [state, setState] = useState({
        progress: 0,
        isModalVisible: false,
        isArtFormEdit: true,
        feedback: profile.feedback,
        name_of_art: profile.name_of_art,
        desc_of_art: profile.desc_of_art,
        art_path:profile.art_path

    })
    const [form] = Form.useForm();
    console.log(form);
    const onFinish = values => {
        // values.monthly_family_income = parseInt(values.monthly_family_income);
        // values.dob = values.dob.format("YYYY-MM-DD");
        // values.email = userDetail.email;
        // values.user_id = userDetail.user_id;
        // action(updateUser(values));
        // // console.log('Success:', values);
    };

    const onFinishFailed = errorInfo => {
        console.log('Failed:', errorInfo);
    };

    const { progress, isModalVisible, feedback, isArtFormEdit, name_of_art, desc_of_art, art_path } = state;

    const getProgress = () => {
        if (!chapters) {
            return 0
        }
        let totalNumber = chapters.length + 1;
        let completedChapters = chapters.filter((chapter) => {
            return chapter.isDone == true
        })
        let completedNumber = (completedChapters && completedChapters.length) ? completedChapters.length : 0;
        if (profile && profile.feedback) {
            completedNumber++;
        }
        let progress = 0;
        if (completedNumber > 0) {
            progress = ((parseInt(completedNumber) / parseInt(totalNumber)) * 100);
            progress = Math.round(progress);
        }
        return progress
    }
     const uploadProps = {
      accept:".png, .jpg, .jpeg, .pdf",
      name: 'file',
      multiple: false,
      maxCount: 1,
      listType:"picture",
      action: 'https://www.tyclinternational.org/art-camp/service/api/upload.php',
      headers: {
        authorization: 'authorization-text',
        "Access-Control-Allow-Origin": "*"
      },
      defaultFileList: ( art_path ? [
        {
          uid: '1',
          name: art_path,
          status: 'done',
          url: art_path,
        }
      ] : [] ),
      onChange(info,aa,bb) {
        if (info.file.status !== 'uploading') {
          console.log(info.file, info.fileList);
        }
        if (info.file.status === 'done') {
          message.success(`${info.file.name} file uploaded successfully`);
          setState({ ...state, art_path: info.file.response.file });

        } else if (info.file.status === 'error') {
          message.error(`${info.file.name} file upload failed.`);
        }
      },
      onRemove() {
        setState({ ...state, art_path: null })
      }
     
    };
    useEffect(() => {
        if (chapters) {
            setState({ ...state, progress: getProgress() });
        }
    }, [chapters])
    useEffect(() => {
        action(getChapterStatus());
    }, [])
    useEffect(() => {
        if (profile) {
            setState({
                ...state,
                isModalVisible: false,
                feedback: profile.feedback,
                progress: getProgress(),
                name_of_art: profile.name_of_art,
                desc_of_art: profile.desc_of_art,
                art_path:profile.art_path
            })
            form.setFieldsValue({
                feedback: profile.feedback,
                art_path:profile.art_path,
                name_of_art: profile.name_of_art,
                desc_of_art: profile.desc_of_art,
            });
            if(profile.feedback) {
                notification["success"]({
                    message: "Your art work has been submitted successfully"
                  });
            }
        } 
    }, [profile])


    const showModal = () => {
        setState({ ...state, isModalVisible: true });
    };

    const handleOk = () => {
        function callback() {
            setState({ ...state, isModalVisible: false, progress: getProgress() });
        }
        let payload = {
            data: {
                id: profile.user_id,
                feedback: feedback,
                name_of_art: name_of_art,
                desc_of_art: desc_of_art,
                art_path: art_path
            }
        }
        action(saveFeedback(payload))
    };

    const handleCancel = () => {
        setState({ ...state, isModalVisible: false });
    };
    return (
        <>
            {
                loading && (<PanelSpinner></PanelSpinner>)
            }
            <div className="site-layout-background" style={{ padding: 24 }}>
                <Title level={4} type="secondary">Your progress on Creative Art Camp program.</Title>
                <Progress percent={progress} status="active" style={{ marginTop: "10px" }} />
            </div>
            <div className="site-layout-background dashboard-bg user-dashboard" >
                <Card title="Creative Art Camp Chapters" className="segmenets">
                    { profile && profile.feedback ? (<p className="segment-desc cong-msg"><strong>Congratulations {profile.name} {profile.last_name} on finishing this course!</strong> <br/> <br/>Thank you for joining us in this journey of creating positive mental health in society. Please generate the certificate of completion.<br/> We hope that it helps you to understand what mental health is, its importance, and how to maintain positive mental health.<br/>If you know anybody who may benefit from this course, let them know that they can take this course too! Take care!
                        <br/><br/><strong>TYCL International Team</strong></p>  ) :
                        (<p className="segment-desc">The complete segment of Creative Art Camp program listed here.</p>)
                    }
                    {
                        (chapters || []).map((item, key) => (
                            item.key == "preAssessment" ? (
                                <Card.Grid className="lesson" style={{ position: "relative" }}>
                                    { item.isDone && <CheckCircleFilled style={selectedCSS} />}
                                    <Link to="/lessons">{item.name}</Link>
                                </Card.Grid>
                            ) :
                                item.key == "postAssessment" ? (
                                    <Card.Grid className="lesson" style={{ position: "relative" }}>
                                        { isAllChapterDone && item.isDone && <CheckCircleFilled style={selectedCSS} />}
                                        {
                                            isPreAssessmentDone && isAllChapterDone ? (<Link to="/lessons/post-assessment" style={{ cursor: "pointer", color: "#40a9ff" }}>{item.name}</Link>)
                                                : (<a className="no-link">  {item.name} </a>)
                                        }
                                    </Card.Grid>
                                ) : (
                                        <Card.Grid key={key} className="lesson" style={{ position: "relative" }}>
                                            { item.isDone && item.isPassed ? <CheckCircleFilled style={selectedCSS} /> : item.isDone ? <CloseCircleFilled style={rejectedCSS} /> : ""}
                                            {

                                                isPreAssessmentDone ? (<Link to={'/lessons/chapter/' + item.key} style={{ cursor: "pointer", color: "#40a9ff" }}>{item.name}</Link>)
                                                    : (<a className="no-link">  {item.name} </a>)
                                            }
                                        </Card.Grid>

                                    )
                        ))
                    }
                    <Card.Grid className="lesson" style={{ position: "relative" }}>
                        {isPostAssessmentDone && feedback && <CheckCircleFilled style={selectedCSS} />}
                        {
                            isPostAssessmentDone ? (<div onClick={showModal} className="anchor-tag" style={{ cursor: "pointer", color: "#40a9ff" }}> Your Art Submission</div>)
                                : (<a className="no-link">Your Art Submission</a>)
                        }
                    </Card.Grid>
                    <Card.Grid className={progress == 100 ? "generate-certificate lesson" :"lesson"}>
                        {
                            progress == 100 ? (<Link to={'/lessons/generate-certificate/' + userId} style={{ cursor: "pointer", color: "#40a9ff" }}> Generate Certificate <SendOutlined /></Link>)
                                : (<a className="no-link">Generate Certificate</a>)
                        }
                    </Card.Grid>
                </Card>
            </div>
            {
                profile && 
                <Modal title="Submit Your Art" visible={isModalVisible} onOk={handleOk} okButtonProps={{ disabled: !feedback || !name_of_art || !desc_of_art , key: 'submit', htmlType: 'submit'}} onCancel={handleCancel} okText="Submit" >
                
                { isArtFormEdit && 
                   <div class="modal-form-holding"> <Form
                        name="basic"
                        // initialValues={initialValues}
                        form={form}
                        onFinish={onFinish}
                        onFinishFailed={onFinishFailed} >
                        <Form.Item>

                            <Input.Group>
                                <Form.Item
                                    name="name_of_art"
                                    rules={[{ required: true, message: 'Please enter the name of Artwork' }]}
                                    style={fullInput}
                                >
                                    <Input placeholder="Name of Artwork" value={name_of_art}  onChange={(e) => { setState({ ...state, name_of_art: e.target.value }) }} />
                                </Form.Item>
                            </Input.Group>
                            <Input.Group>
                                <Form.Item
                                    name="desc_of_art"
                                    rules={[{ required: true, message: 'Please enter the description of Artwork' }]}
                                    style={fullInput}
                                >
                                    <TextArea rows={7} placeholder="Description of Artwork" value={desc_of_art} onChange={(e) => { setState({ ...state, desc_of_art: e.target.value }) }} />

                                </Form.Item>
                            </Input.Group>
                            <Input.Group>
                                <Upload {...uploadProps} multiple={false} max={1} maxCount={1}>
                                    <Button icon={<UploadOutlined />} disabled={art_path}>Upload your Artwork</Button>
                                </Upload>
                                <p style={{textAlign:"justify",marginTop:"10px"}}>Direction: Scan your artwork. To maintain the quality of the artwork, it has to be scanned. Mobile phone pictures of artwork will not be accepted for publications.  Image files should be in JPG/PNG format and file size  is no more than 10 MB.</p>
                            </Input.Group>
                            <Input.Group>
                                <Form.Item
                                    name="feedback"
                                    rules={[{ required: true, message: 'Please give your feedback' }]}
                                    style={fullInput}
                                >
                                    <TextArea rows={7} placeholder="Your feedback about virtual art camp" value={feedback} onChange={(e) => { setState({ ...state, feedback: e.target.value }) }} />

                                </Form.Item>
                            </Input.Group>
                        </Form.Item>


                    </Form></div>
                }
                { !isArtFormEdit && 

                    <div>
                      <h4>Overcome Covid'19</h4>
                      <p>To overcome covid'19, together fight with safety measures.</p>
                      <img />
                    </div>
                }

            </Modal>
            }
        </>
    )
}
export default Dashboard